export default {
  seoMeta: {},
};
